<template>
  <v-main>
    <AppBar title="검색" extension-height="70px">
      <div class="flex-fill fill-height">
        <div class="search-area" @click="searchSheet=true">
          <img :src="getImage('ic_search.svg')" class="search-icon" />
          <input type="text" class="search-input" placeholder="검색해보세요." value="" />
        </div>
      </div>
    </AppBar>
    <!-- 리스트 없는 경우 -->
    <div class="d-flex justify-space-between align-center" v-if="sbitems.length === 0">
      <div class="fs-14 secondary--text mt-3">데이터가 없습니다.</div>
    </div>
    <!-- 리스트 있는 경우 -->
    <div class="mb-5" v-else v-for="sbitem in sbitems" :key="sbitem.subject">
      <div class="d-flex justify-space-between align-center inner mb-1">
        <h2 class="fs-16">{{ sbitem.subjectNm }}
          <span class="primary--text">{{ sbitem.len }}</span>
        </h2>
        <v-btn plain :ripple="false" class="btn-allView" @click="allView(sbitem.subject)">
          <img :src="getImage('ic_arrow_right.svg')" class="arrow">
        </v-btn>
      </div>
      <Flicking :options="{bound: true, align: 'prev'}" class="inner">
        <div v-for="(item, index) in items" :key="index"
             v-show="sbitem.subject == item.subject"
             class="items"
             @click="readOne(item.libNo, item.type)"
        >
          <v-img :src="$downUrl(item.thnImgFileName)" aspect-ratio="1" width="120" height="120" class="rounded"></v-img>
          <div class="item-title">{{item.title}}</div>
        </div>
      </Flicking>
    </div>
    <!-- 수정하기 모달-->
    <LibrarySearchDetailsModal :dialog="searchSheet" @close="searchModalClose"/>
<!--    <BottomMenu :current="1"/>-->
  </v-main>
</template>
<script>
import LibrarySearchDetailsModal from "./LibrarySearchDetailsModal";
// import BottomMenu from '@/components/layout/BottomMenu'
export default {
    data: () => ({
        filter: [
            {
                cd:'regDt',
                name: '최신순'
            },
            {
                cd:'inqCnt',
                name: '조회수'
            },
            {
                cd:'likeCnt',
                name: '좋아요'
            }
        ],
        filterItem: '0',
        filterCd: 'regDt',
        sbitems: [],
        items: [],
        searchSheet: false,
    }),
    mounted() {
        this.subjectItems(this.$route.params.contentlist)
    },
    components:{
        // BottomMenu,
        LibrarySearchDetailsModal
    },
    methods:{
        searchModalClose(data){
            this.subjectItems(data);
            this.searchSheet = false;
        },
        subjectItems(clist) {

            if (clist !== null && clist !== undefined) {
                this.items = []
                this.items = clist

                this.sbitems = []
                const arr = {};
                this.sbitems = [...new Map(this.items.map(item =>
                    [item.subject, {subject: item.subject, subjectNm: item.subjectNm, len: (arr[item.subject] = (arr[item.subject] || 0) + 1)}])).values()];

                this.sbitems.sort(function(a, b){
                    return a.subject - b.subject;
                })
            }
        },
        librarySearch(){
           this.movePage('/fo/library/search');
        },
        libraryLike(){
            alert("도서관 like")
        },
        allView(subjectVal){
            this.$router.push({name: '도서관 상세', params: {'subjectNo': subjectVal, reload: true}})
        },
        async readOne (libNo, typeItem) {
            this.$router.push({name: '도서관상세' + typeItem, params: {'libNo': libNo, 'contentlist': this.items}})
        },
    }
}
</script>
